import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import logoWhite from '../media/logo_white.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-accent text-white w-screen relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-white to-primary opacity-50"></div>
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-white opacity-5 rounded-full"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-white opacity-5 rounded-full"></div>

      {/* Main Footer Content */}
      <div className="relative w-full px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto">
          {/* Top Section with Logo and Description */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            {/* Left Side - Logo and Description */}
            <div className="space-y-8">
              <div className="flex items-center space-x-6">
                <img 
                  src={logoWhite} 
                  alt="Dr. Banelhaq Ayoub - Cabinet Dentaire" 
                  className="h-20 w-auto"
                />
                <div>
                  <h2 className="text-3xl font-bold tracking-tight">Dr. Banelhaq Ayoub</h2>
                  <p className="text-gray-300 mt-1">Cabinet Dentaire</p>
                </div>
              </div>
              <p className="text-gray-300 text-base leading-relaxed max-w-lg mx-auto text-center">
                Cabinet dentaire moderne offrant des soins de qualité avec une approche centrée sur le patient. Nous nous engageons à fournir une expérience dentaire exceptionnelle.
              </p>
              <div className="flex justify-center mb-12">
                <a 
                  href="https://wa.me/212684707407" 
                  className="flex items-center justify-center bg-green-600 py-3 px-6 rounded-lg text-white text-sm font-medium hover:bg-green-700 transition-all duration-300 transform hover:scale-105"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Contacter par WhatsApp
                </a>
              </div>
            </div>

            {/* Right Side - Contact Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
  <div className="space-y-6 text-center">
    <h3 className="text-xl font-semibold relative block mb-4">
      Contactez-nous
      <span className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-white"></span>
    </h3>
    <div className="space-y-4 text-left mx-auto max-w-max">
      {/* Phone */}
      <div className="group flex items-start">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors flex-shrink-0">
          <FontAwesomeIcon icon={faPhone} className="h-5 w-5 text-white" />
        </div>
        
          <div className="flex flex-col ml-4">
            <p className="text-sm text-gray-400">Téléphone</p>
            <a href="tel:+212684707407" className="flex-grow text-gray-300 hover:text-white transition-colors">
            <p className="font-medium">+212 6 84 70 74 07</p></a>
            <a href="tel:+212539434067" className="flex-grow text-gray-300 hover:text-white transition-colors">
              <p className="font-medium">+212 5 39 43 40 67</p>
              </a>
          </div>
        
      </div>
      

      {/* Email */}
      <div className="group flex items-start">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors flex-shrink-0">
          <FontAwesomeIcon icon={faEnvelope} className="h-5 w-5 text-white" />
        </div>
        <a href="mailto:contact@docteurbanelhaq.com" className="flex-grow text-gray-300 hover:text-white transition-colors">
          <div className="flex flex-col ml-4">
            <p className="text-sm text-gray-400">Email</p>
            <p className="font-medium">dental.banelhaq@gmail.com</p>
          </div>
        </a>
      </div>

      {/* Address */}
      <div className="group flex items-start">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors flex-shrink-0">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="h-5 w-5 text-white" />
        </div>
        <a href="#" className="flex-grow text-gray-300 hover:text-white transition-colors">
          <div className="flex flex-col ml-4">
            <p className="text-sm text-gray-400">Adresse</p>
            <p className="font-medium">N 86 Lotissement Karima 3, Av Royaume d'arabie saoudite, en face hotel Ahlan, Tanger</p>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div className="space-y-6 text-center">
    <h3 className="text-xl font-semibold relative block mb-4">
      Horaires
      <span className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-white"></span>
    </h3>
    <div className="space-y-4 text-left mx-auto max-w-max">
      <div className="group flex items-start">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors flex-shrink-0">
          <FontAwesomeIcon icon={faClock} className="h-5 w-5 text-white" />
        </div>
        <div className="ml-4">
          <p className="text-sm text-gray-400">Lundi - Vendredi</p>
          <p className="font-medium text-gray-300">10h - 19h</p>
          <p className="text-sm text-gray-400 mt-2">Samedi</p>
          <p className="font-medium text-gray-300">10h - 14h</p>
          <p className="text-sm text-gray-400 mt-2">Dimanche</p>
          <p className="font-medium text-gray-300">Fermé</p>
        </div>
      </div>
    </div>
  </div>
</div>
          </div>

          {/* Middle Section - Quick Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
            <div className="flex flex-col items-center">
              <h3 className="text-lg font-semibold mb-6">Navigation</h3>
              <ul className="space-y-4 text-center">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/rendez-vous" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Rendez-vous
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-center">
              <h3 className="text-lg font-semibold mb-6">Services</h3>
              <ul className="space-y-4 text-center">
                <li>
                  <Link to="/services#implantologie" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Implantologie
                  </Link>
                </li>
                <li>
                  <Link to="/services#orthodontie" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Orthodontie
                  </Link>
                </li>
                <li>
                  <Link to="/services#esthetique" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Esthétique
                  </Link>
                </li>
                <li>
                  <Link to="/services#soins" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Soins dentaires
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-center">
              <h3 className="text-lg font-semibold mb-6">Informations</h3>
              <ul className="space-y-4 text-center">
                <li>
                  <Link to="/about" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    À propos
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Confidentialité
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-gray-300 hover:text-white transition-colors flex items-center justify-center group">
                    <span className="w-0 group-hover:w-2 h-0.5 bg-white mr-0 group-hover:mr-2 transition-all duration-300"></span>
                    Conditions
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-center">
              <h3 className="text-lg font-semibold mb-6">Suivez-nous</h3>
              <div className="space-y-4 text-center">
                <p className="text-gray-300">Restez informé de nos actualités et conseils dentaires.</p>
                <div className="flex justify-center space-x-4">
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section - Copyright */}
          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm">
                © {currentYear} Cabinet Dr. Banelhaq Ayoub. Tous droits réservés.
              </p>
              <div className="flex space-x-6">
                <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">Politique de confidentialité</Link>
                <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">Conditions d'utilisation</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 